import React from 'react';
import {Header, Stat, Team, TeamImage} from 'app/components/standings/StandingsStyles';
import {Typography} from '@fupa/fupa-uikit';

const AlltimeHeader = () => {
  return (
    <Header>
      <Stat align='left' setMaxWidth minWidth={24}>
        <Typography variant='caption1'>Pl.</Typography>
      </Stat>
      <TeamImage />
      <Team>
        <Typography variant='caption1'>Team</Typography>
      </Team>
      <Stat align='center' minWidth={32}>
        <Typography variant='caption1'>Jahre</Typography>
      </Stat>
      <Stat align='center' minWidth={36}>
        <Typography variant='caption1'>Sp.</Typography>
      </Stat>
      <Stat align='center' conditional minWidth={36}>
        <Typography variant='caption1'>S</Typography>
      </Stat>
      <Stat align='center' conditional minWidth={36}>
        <Typography variant='caption1'>U</Typography>
      </Stat>
      <Stat align='center' conditional minWidth={36}>
        <Typography variant='caption1'>N</Typography>
      </Stat>
      <Stat align='center' conditional minWidth={36}>
        <Typography variant='caption1'>Diff.</Typography>
      </Stat>
      <Stat align='center' conditional minWidth={72}>
        <Typography variant='caption1'>Tore</Typography>
      </Stat>
      <Stat align='center' minWidth={36}>
        <Typography variant='caption1'>
          Pkt.<sup>1)</sup>
        </Typography>
      </Stat>
    </Header>
  );
};

export default AlltimeHeader;
